<template>
  <div class="page">
    <component
      :is="currentComponent"
      @choose="onChoose"
      @registered="onRegistered"
    ></component>
  </div>
</template>

<script>
import Chooser from "@/components/registration/Chooser";
import Organization from "@/components/registration/Organization";
import Pathologist from "@/components/registration/Pathologist";
import Researcher from "@/components/registration/Researcher";

export default {
  data() {
    return {
      currentComponent: null
    };
  },
  methods: {
    onChoose(item) {
      if (item === "organization") this.currentComponent = Organization;
      if (item === "pathologist") this.currentComponent = Pathologist;
      if (item === "researcher") this.currentComponent = Researcher;
    },
    onRegistered() {
      this.$router.replace({ name: "registration-success" });
    }
  },
  mounted() {
    this.currentComponent = Chooser;
  }
};
</script>

<style lang="scss" scoped>
.entity {
  transition: opacity 0.4s ease-in-out;

  .icon img {
    width: 100px;
  }
}

.on-hover {
  cursor: pointer;
}

.entity:not(.on-hover) {
  opacity: 0.6;
}
</style>
